import { alpha } from '@mui/material/styles';
import { typeVar } from '../typeRoles';

// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        // MUI hard-codes 13px/15px for small/large buttons; route them through the
        // dashboard "Button text" role too (fallbacks = MUI's originals for admin).
        sizeSmall: {
          fontSize: typeVar('button', 'size', theme.typography.pxToRem(13)),
        },
        sizeLarge: {
          height: 48,
          fontSize: typeVar('button', 'size', theme.typography.pxToRem(15)),
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
